import React, { PureComponent } from 'react';
import cx from 'classnames';

export class RadioGroup extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			value: props.value
		};
	}

	onChange = (e) => {
		this.setState({
			value: e.target.value
		});
		this.props.onChange && this.props.onChange(e);
	};

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.props.value) {
			this.setState({
				value: nextProps.value
			});
		}
	}

	render() {
		let childrenWithProps = React.Children.map(
			this.props.children,
			(child) =>
				React.cloneElement(child, {
					name: this.props.name,
					onChange: this.onChange.bind(this),
					isChecked: this.state.value === child.props.value
				})
		);

		let wraperClass = {};
		if (this.props.className) {
			wraperClass[this.props.className] = true;
		}

		return <div className={cx(wraperClass)}>{childrenWithProps}</div>;
	}
}
